import { useEffect, useState } from "react";
import axios from "axios";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid
} from "recharts";

export default function ProjectSCurve({ projectId }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(`/api/dashboard/project-scurve/${projectId}`, {
        withCredentials: true
      })
      .then((res) => setData(res.data))
      .catch((err) => console.error(err));
  }, [projectId]);

  return (
    <ResponsiveContainer width="100%" height={350}>
      <LineChart data={data}>
        {/* Grid */}
        <CartesianGrid strokeDasharray="4 4" stroke="#e5e7eb" />

        {/* Axes */}
        <XAxis dataKey="time" />
        <YAxis domain={[0, 100]} />

        {/* Tooltip + Legend */}
        <Tooltip />
        <Legend />

        {/* Planned Progress Line */}
        <Line
          type="monotone"
          dataKey="planned"
          stroke="#22c55e"
          strokeWidth={3}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
          name="Planned"
          animationDuration={1200}
        />

        {/* Actual Progress Line */}
        <Line
          type="monotone"
          dataKey="actual"
          stroke="#3b82f6"
          strokeWidth={3}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
          name="Actual"
          animationDuration={1200}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}